import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import {
  Card,
  Form,
  Row,
  Col,
  Button,
  Modal,
} from "@themesberg/react-bootstrap";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";

import { GetSingleUser, reset } from "../../../features/userSlice";
import {
  GetAllJenisPembiayaanDropdown,
  reset as resetJenisPembiayaan,
} from "../../../features/jenisPembiayaanSlice";
import {
  GetAllStaffMenuDropdown,
  reset as resetStaffMenu,
} from "../../../features/StaffMenuSlice";

import api from "../../../api";
import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";
import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";
import { getYearsList, validateNumericInput } from "../../../helpers/helper";
import BASE_URL from "../../../api";

const FormData = () => {
  const [dataRole, setDataRole] = useState([]);
  const [dataFakultas, setDataFakultas] = useState([]);
  const [dataProdi, setDataProdi] = useState([]);
  const [newDataUser, setNewDataUser] = useState({
    username: "",
    nama: "",
    email: "",
    id_fakultas: "",
    id_prodi: "",
    id_role: "",
    nip: "",
    no_hp: "",
    tahun_angkatan: "",
    id_jenis_pembiayaan: "",
    password: "",
  });
  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector(
    (state) => state.user
  );
  const { 
    data: dataStaffMenu, 
    isLoading: isLoadingStaffMenu,
    isError: isErrorStaffMenu,
   } = useSelector(
    (state) => state.staffMenu
  );
  const {
    data: dataJenisPembiayaan,
    isLoading: isLoadingJenisPembiayaanList,
    isError: isErrorJenisPembiayaanList,
  } = useSelector((state) => state.jenisPembiayaan);

  const token = localStorage.getItem("token");

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      // call api to fetch fakultas dropdown data
      dispatch(reset());
      dispatch(resetJenisPembiayaan());
      dispatch(GetAllJenisPembiayaanDropdown({ token }));
      dispatch(GetSingleUser({ id, token }));
    }
  }, [dispatch, token, id]);
  
  useEffect(() => {
    if (id && data) {
      if (data?.data?.id_role === "HA04") {
        // call api to fetch fakultas dropdown data
        dispatch(resetStaffMenu());
        dispatch(GetAllStaffMenuDropdown({ token }));
      }
    }
  }, [dispatch, token, id, data]);

  useEffect(() => {
    const source = axios.CancelToken.source();
    const fetchData = async () => {
      try {
        // ambil data role
        const roleResponse = await axios.get(`${api}master/role`, {
          cancelToken: source.token,
        });

        const roleFormated = roleResponse.data.data.map((roles) => ({
          value: roles.id,
          label: roles.nama,
          isDisabled: roles.id === "HA05",
        }));

        setDataRole(roleFormated);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
    return () => {
      source.cancel("Komponen dibongkar, membatalkan permintaan.");
    };
  }, [token]);

  // call on init
  useEffect(() => {
    const source = axios.CancelToken.source();
    const fetchData = async () => {
      try {
        // Ambil data fakultas
        const fakultasResponse = await axios.get(`${api}/master/fakultas`, {
          cancelToken: source.token,
        });

        const fakultasFormated = fakultasResponse.data.data.map((fakultas) => ({
          value: fakultas.id,
          label: fakultas.nama,
        }));
        setDataFakultas(fakultasFormated);
      } catch (error) {
        console.log("ERROR FETCH FAKULTAS : ", error);
      }
    };

    fetchData();
    return () => {
      source.cancel("Komponen dibongkar, membatalkan permintaan.");
    };
  }, [token]);

  // call if the id_fakultas is changed
  useEffect(() => {
    const source = axios.CancelToken.source();
    const fetchData = async () => {
      try {
        // Jika newUser.id_fakultas tidak kosong, ambil data prodi
        if (newDataUser.id_fakultas) {
          const prodiResponse = await axios.get(
            `${api}/master/prodi/get_by_fakultas_id/${newDataUser.id_fakultas}`,
            {
              cancelToken: source.token,
            }
          );
          const prodiFormated = prodiResponse.data.data.map((prodi) => ({
            value: prodi.id,
            label: prodi.nama,
          }));
          setDataProdi(prodiFormated);
        } else {
          // Jika newUser.id_fakultas kosong, set dataProdi menjadi array kosong
          setDataProdi([]);
        }
      } catch (error) {
        console.log("ERROR FETCH PRODI : ", error);
      }
    };

    fetchData();
    return () => {
      source.cancel("Komponen dibongkar, membatalkan permintaan.");
    };
  }, [newDataUser.id_fakultas]);

  function getJenisPembiayaanList() {
    try {
      const result = dataJenisPembiayaan?.data?.map((item, i) => ({
        value: item,
        label: item.nama,
      }));
      return result;
    } catch (error) {
      return [];
    }
  }

  function getStaffMenuList() {
    try {
      const result = dataStaffMenu?.data?.map((item, i) => ({
        value: item,
        label: item.nama,
      }));
      return result;
    } catch (error) {
      return [];
    }
  }

  useEffect(() => {
    setNewDataUser({
      username: data?.data?.username,
      nama: data?.data?.nama,
      email: data?.data?.email,
      nip: data?.data?.nip,
      id_fakultas: data?.data?.id_fakultas,
      id_prodi: data?.data?.id_prodi,
      no_hp: data?.data?.no_hp,
      tahun_angkatan: data?.data?.tahun_angkatan,
      id_role: data?.data?.id_role,
      id_jenis_pembiayaan: data?.data?.id_jenis_pembiayaan,
      id_staff_menu: data?.data?.id_staff_menu,
    });
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    showAlertDialog({
      title: id ? "Update?" : "Simpan?",
      msg: `apakah anda yakin ingin ${
        id ? "mengupdate" : "menyimpan"
      } data ini?`,
      confirmButtonText: id ? "Update" : "Simpan",
      onConfirm: async () => {
        showLoadingDialog();
        let response;
        try {
          if (id) {
            response = await axios.put(
              `${BASE_URL}user/update/${id}`,
              {
                username: newDataUser.username,
                nama: newDataUser.nama,
                email: newDataUser.email,
                id_fakultas: newDataUser.id_fakultas,
                id_prodi: newDataUser.id_prodi,
                nip: newDataUser.nip,
                no_hp: newDataUser.no_hp,
                // id_role: newDataUser.id_role,
                tahun_angkatan: newDataUser.tahun_angkatan,
                id_jenis_pembiayaan: newDataUser.id_jenis_pembiayaan.id,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            response = await axios.post(
              `${BASE_URL}user`,
              {
                username: newDataUser.username,
                nama: newDataUser.nama,
                email: newDataUser.email,
                id_fakultas: newDataUser.id_fakultas,
                id_prodi: newDataUser.id_prodi,
                nip: newDataUser.nip,
                no_hp: newDataUser.no_hp,
                id_role: newDataUser.id_role,
                password: newDataUser.password,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          navigate(`/master/user/list`);
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[3] === "view" ? (
        <>
          <Header title="Detail User">
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/${param.pathname.split("/")[2]}/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "add" ? (
        <>
          <Header title="Tambah User">
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/${param.pathname.split("/")[2]}/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}
      <ModalLoading isLoading={isLoading} />
      <Card>
        <FormPage
          id={id}
          dataFakultas={dataFakultas}
          dataProdi={dataProdi}
          handleSubmit={handleSubmit}
          newDataUser={newDataUser}
          setNewDataUser={setNewDataUser}
          dataRole={dataRole}
          isLocked={param.pathname.split("/")[3] === "view"}
          isLoadingJenisPembiayaanList={isLoadingJenisPembiayaanList}
          dataJenisPembiayaan={getJenisPembiayaanList()}
          isLoadingStaffMenu={isLoadingStaffMenu}
          dataStaffMenu={getStaffMenuList()}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = ({
  handleSubmit,
  newDataUser: newDataUser,
  setNewDataUser,
  isLoadingJenisPembiayaanList,
  dataJenisPembiayaan,
  isLoadingStaffMenu,
  dataStaffMenu,
  dataFakultas,
  dataProdi,
  dataRole,
  id,
  isLocked = false,
}) => {

  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const updateStaffMenu = async (id_staff_menu) => {
    showLoadingDialog();
    try {
      const response = await axios.put(
        `${BASE_URL}user/update/${id}`,
        {
          ...newDataUser,
          id_staff_menu: id_staff_menu,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      console.log("RESPONSE : ", response);
      hideLoadingDialog();
      showSuccessDialog({
        title: "Berhasil!",
        msg: "Berhasil menyimpan data!",
      });
    } catch (error) {
      console.log("ERROR", error);
      hideLoadingDialog();
      showFailedDialog({
        title: "Oops!",
        msg: error?.response?.data?.message || "Gagal menyimpan data!",
      });
    }
  }

  const resetPassword = async () => {
    showLoadingDialog();
    try {
      const response = await axios.put(
        `${BASE_URL}user/reset_password_admin/${id}`,
        {},
        {
          headers: {
            Authorization: token,
          },
        }
      );
      console.log("RESPONSE : ", response);
      hideLoadingDialog();
      showSuccessDialog({
        title: "Berhasil!",
        msg: "Berhasil mereset password data!",
      });
      navigate(`/master/user/list`);
    } catch (error) {
      console.log("ERROR", error);
      hideLoadingDialog();
      showFailedDialog({
        title: "Oops!",
        msg: error?.response?.data?.message || "Gagal menyimpan data!",
      });
    }
  }

  return (
    <Card.Body>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12} className="mb-3">
            <Form.Group id="username">
              <Form.Label>Username</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Username"
                name="username"
                disabled={isLocked}
                value={newDataUser.username || ""}
                onChange={(e) =>
                  setNewDataUser({
                    ...newDataUser,
                    username: e.target.value,
                  })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="nama">
              <Form.Label>Nama</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Nama"
                name="nama"
                disabled={isLocked}
                value={newDataUser.nama || ""}
                onChange={(e) =>
                  setNewDataUser({
                    ...newDataUser,
                    nama: e.target.value,
                  })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                required
                type="email"
                placeholder="Email"
                name="email"
                disabled={isLocked}
                value={newDataUser.email || ""}
                onChange={(e) =>
                  setNewDataUser({
                    ...newDataUser,
                    email: e.target.value,
                  })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="id_fakultas">
              <Form.Label>Fakultas</Form.Label>
              <Select
                options={dataFakultas}
                isDisabled={isLocked}
                placeholder="Pilih fakultas"
                value={dataFakultas.find(
                  (item) => item.value === newDataUser.id_fakultas
                )}
                isClearable={true}
                onChange={(e) => {
                  setNewDataUser({
                    ...newDataUser,
                    id_fakultas: e?.value,
                  });
                }}
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="id_prodi">
              <Form.Label>Prodi</Form.Label>
              <Select
                options={dataProdi}
                placeholder="Pilih Prodi"
                value={dataProdi.find(
                  (item) => item.value === newDataUser.id_prodi
                )}
                isDisabled={!newDataUser.id_fakultas || isLocked}
                isClearable={true}
                onChange={(e) => {
                  setNewDataUser({
                    ...newDataUser,
                    id_prodi: e?.value,
                  });
                }}
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="no_hp">
              <Form.Label>No. HP</Form.Label>
              <Form.Control
                type="text"
                placeholder="No. HP"
                name="no_hp"
                disabled={isLocked}
                value={newDataUser.no_hp || ""}
                onChange={(e) =>
                  setNewDataUser({
                    ...newDataUser,
                    no_hp: validateNumericInput(e.target.value, 16),
                  })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="id_role">
              <Form.Label>Role</Form.Label>
              <Select
                options={dataRole}
                placeholder="Pilih Role"
                value={dataRole.find(
                  (item) => item.value === newDataUser.id_role
                )}
                required
                isDisabled={isLocked || id}
                onChange={(e) => {
                  setNewDataUser({
                    ...newDataUser,
                    id_role: e.value,
                  });
                }}
              />
            </Form.Group>
          </Col>
          {isLocked && newDataUser?.id_role == "HA04" ? (
            <Col md={12} className="mb-3">
              <Form.Group id="staff_menu">
                <Form.Label>Staff Menu</Form.Label>
                <Select
                  options={dataStaffMenu}
                  placeholder="Pilih Staff Menu"
                  value={dataStaffMenu?.find(
                    (item) => item.value.id === newDataUser.id_staff_menu
                  )}
                  required
                  onChange={(e) => {
                    setNewDataUser({
                      ...newDataUser,
                      id_staff_menu: e.value.id,
                    });
                    updateStaffMenu(e.value.id)
                  }}
                />
              </Form.Group>
            </Col>
          ) : null}
          {newDataUser?.id_role == "HA05" ? (
            <>
              <Col md={12} className="mb-3">
                <Form.Group id="tahun_angkatan">
                  <Form.Label>Tahun Angkatan</Form.Label>
                  <Select
                    options={getYearsList()}
                    placeholder="Pilih Tahun"
                    required
                    value={getYearsList().find(
                      (item) =>
                        `${item.value}` === `${newDataUser.tahun_angkatan}`
                    )}
                    isDisabled={isLocked}
                    onChange={(e) => {
                      setNewDataUser({
                        ...newDataUser,
                        tahun_angkatan: e.value,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={12} className="mb-3">
                <Form.Group id="id_jenis_pembiayaan">
                  <Form.Label>Jenis Pembiayaan</Form.Label>
                  <Select
                    options={dataJenisPembiayaan}
                    placeholder="Pilih jenis pembiayaan"
                    required
                    value={dataJenisPembiayaan?.find(
                      (e) => e.value.id === newDataUser?.id_jenis_pembiayaan
                    )}
                    isDisabled={isLocked}
                    isLoading={isLoadingJenisPembiayaanList}
                    onChange={(e) => {
                      setNewDataUser({
                        ...newDataUser,
                        id_jenis_pembiayaan: e.value,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
            </>
          ) : (
            <>
              <Col md={12} className="mb-3">
                <Form.Group id="nip">
                  <Form.Label>NIP</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="NIP"
                    name="nip"
                    disabled={isLocked}
                    value={newDataUser.nip || ""}
                    onChange={(e) =>
                      setNewDataUser({
                        ...newDataUser,
                        nip: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Col>
            </>
          )}
          {!isLocked && !id ? (
            <Col md={12} className="mb-3">
              <Form.Group id="password">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  required
                  type="password"
                  placeholder="Password"
                  name="password"
                  disabled={isLocked}
                  value={newDataUser.password || ""}
                  onChange={(e) =>
                    setNewDataUser({
                      ...newDataUser,
                      password: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
          ) : null}
        </Row>
        <div>
          {!isLocked ? (
            <Button type="submit">{id ? "Update" : "Simpan"}</Button>
          ) : <Button variant="danger" onClick={resetPassword}>{"Reset Password"}</Button>}
        </div>
      </Form>
    </Card.Body>
  );
};

const ModalLoading = ({ isLoading }) => {
  return (
    <Modal as={Modal.Dialog} centered show={isLoading}>
      <Modal.Body>
        <p>Loading...</p>
      </Modal.Body>
    </Modal>
  );
};

export default FormData;
